import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShopStarRating = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "shop-star-rating" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M11.564,13.768a.488.488,0,0,1,.871,0l1.013,2.042a.486.486,0,0,0,.365.263l2.272.328a.483.483,0,0,1,.391.325.474.474,0,0,1-.121.489l-1.65,1.6a.476.476,0,0,0-.138.421l.389,2.255a.473.473,0,0,1-.194.467.491.491,0,0,1-.511.035l-2.024-1.059a.492.492,0,0,0-.454,0L9.749,21.993a.491.491,0,0,1-.511-.035.473.473,0,0,1-.194-.467l.388-2.255a.475.475,0,0,0-.137-.421l-1.65-1.6a.472.472,0,0,1-.121-.489.481.481,0,0,1,.39-.325l2.272-.328a.488.488,0,0,0,.366-.263Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6,23.25H3.75a1.5,1.5,0,0,1-1.5-1.5v-9"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21.75,12.75v9a1.5,1.5,0,0,1-1.5,1.5H18"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21.148.75H2.852a.751.751,0,0,0-.733.587L.75,7.5a2.25,2.25,0,0,0,4.5,0,2.25,2.25,0,0,0,4.5,0,2.25,2.25,0,0,0,4.5,0,2.25,2.25,0,0,0,4.5,0,2.25,2.25,0,0,0,4.5,0L21.88,1.337A.749.749,0,0,0,21.148.75Z"
		})
	]
});
export default SvgShopStarRating;
